import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1890FF",
  d: "m17.924 2.907-.829-.828a.162.162 0 0 0-.223 0l-1.485 1.486a3.9 3.9 0 0 0-2.19-.67c-1 0-2 .38-2.764 1.145l-1.99 1.99a.157.157 0 0 0 0 .22l5.307 5.307q.048.046.111.045c.04 0 .08-.016.111-.045l1.99-1.99a3.91 3.91 0 0 0 .475-4.951l1.487-1.487a.16.16 0 0 0 0-.222m-2.903 5.72-1.16 1.16-3.648-3.648 1.16-1.16a2.57 2.57 0 0 1 1.824-.756c.69 0 1.336.268 1.824.756.486.486.756 1.135.756 1.824s-.27 1.336-.756 1.824m-3.715 2.051a.157.157 0 0 0-.22 0L9.785 11.98 8.02 10.215l1.303-1.302c.06-.061.06-.16 0-.221l-.711-.711a.157.157 0 0 0-.22 0L7.09 9.284l-.84-.84a.15.15 0 0 0-.112-.045c-.039 0-.08.016-.11.045l-1.99 1.99a3.91 3.91 0 0 0-.474 4.951l-1.486 1.487a.157.157 0 0 0 0 .22l.828.828q.048.047.111.045.063 0 .112-.045l1.486-1.486c.658.447 1.424.67 2.19.67 1 0 2-.38 2.763-1.144l1.99-1.99c.06-.061.06-.16 0-.222l-.84-.84 1.303-1.302c.06-.06.06-.16 0-.22zm-2.68 4.344a2.57 2.57 0 0 1-1.824.756 2.56 2.56 0 0 1-1.824-.756 2.57 2.57 0 0 1-.756-1.824c0-.69.268-1.336.756-1.825l1.16-1.16 3.649 3.649z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }